"use client"

import { useEffect } from 'react'

import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from 'shared/config/store'
import { isAuthSelector } from 'features/user/model/selectors/userSelectors'

import { logoutThunk } from '../model/slice/userSlice'

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [searchParams] = useSearchParams()
  const isAuth = useAppSelector(isAuthSelector)

  useEffect(() => {
    if (!isAuth) {
      const redirectParam = searchParams.get('fchash')
      const redirectUrl = redirectParam ? `/?fchash=${redirectParam}` : '/'
      dispatch(logoutThunk())
      
      navigate(redirectUrl, { replace: true })
    }
  }, [isAuth, searchParams, navigate])

  if (!isAuth) {
    return null
  }

  return (
    <>
      {children}
    </>
  )
} 